import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BiArrowBack } from 'react-icons/bi';
import { MdDelete, MdAdd } from 'react-icons/md';
import { AiOutlineCheckCircle } from 'react-icons/ai';

const stateData = [
    { label: 'Alabama', value: 'Alabama' },
    { label: 'Alaska', value: 'Alaska' },
    { label: 'Arizona', value: 'Arizona' },
    { label: 'Arkansas', value: 'Arkansas' },
    { label: 'California', value: 'California' },
    { label: 'Colorado', value: 'Colorado' },
    { label: 'Connecticut', value: 'Connecticut' },
    { label: 'Delaware', value: 'Delaware' },
    { label: 'Florida', value: 'Florida' },
    { label: 'Georgia', value: 'Georgia' },
    { label: 'Hawaii', value: 'Hawaii' },
    { label: 'Idaho', value: 'Idaho' },
    { label: 'Illinois', value: 'Illinois' },
    { label: 'Indiana', value: 'Indiana' },
    { label: 'Iowa', value: 'Iowa' },
    { label: 'Kansas', value: 'Kansas' },
    { label: 'Kentucky', value: 'Kentucky' },
    { label: 'Louisiana', value: 'Louisiana' },
    { label: 'Maine', value: 'Maine' },
    { label: 'Maryland', value: 'Maryland' },
    { label: 'Massachusetts', value: 'Massachusetts' },
    { label: 'Michigan', value: 'Michigan' },
    { label: 'Minnesota', value: 'Minnesota' },
    { label: 'Mississippi', value: 'Mississippi' },
    { label: 'Missouri', value: 'Missouri' },
    { label: 'Montana', value: 'Montana' },
    { label: 'Nebraska', value: 'Nebraska' },
    { label: 'Nevada', value: 'Nevada' },
    { label: 'New Hampshire', value: 'New Hampshire' },
    { label: 'New Jersey', value: 'New Jersey' },
    { label: 'New Mexico', value: 'New Mexico' },
    { label: 'New York', value: 'New York' },
    { label: 'North Carolina', value: 'North Carolina' },
    { label: 'North Dakota', value: 'North Dakota' },
    { label: 'Ohio', value: 'Ohio' },
    { label: 'Oklahoma', value: 'Oklahoma' },
    { label: 'Oregon', value: 'Oregon' },
    { label: 'Pennsylvania', value: 'Pennsylvania' },
    { label: 'Rhode Island', value: 'Rhode Island' },
    { label: 'South Carolina', value: 'South Carolina' },
    { label: 'South Dakota', value: 'South Dakota' },
    { label: 'Tennessee', value: 'Tennessee' },
    { label: 'Texas', value: 'Texas' },
    { label: 'Utah', value: 'Utah' },
    { label: 'Vermont', value: 'Vermont' },
    { label: 'Virginia', value: 'Virginia' },
    { label: 'Washington', value: 'Washington' },
    { label: 'West Virginia', value: 'West Virginia' },
    { label: 'Wisconsin', value: 'Wisconsin' },
    { label: 'Wyoming', value: 'Wyoming' }
];

const initialFormState = {
    equipmentId: '',
    model: '',
    size: '',
    setpointTemp: '',
    orientation: '',
    shrouding: false,
    insulation: false,
    typeOfCooling: '',
    notes: '',
    equipmentSectionsSizes: [{
        id: 1,
        circumference: '',
        width: '',
        surfaceArea: 0,
        tb: '',
        notes: ''
    }],
};

const BarrelBlanketEditForm = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [date] = useState(new Date());
    const [username, setUsername] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [utility, setUtility] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [barrelEntries, setBarrelEntries] = useState([{
        ...initialFormState,
        id: 1,
        equipmentSectionsSizes: [{
            id: 1,
            circumference: '',
            width: '',
            surfaceArea: 0,
            tb: '',
            notes: ''
        }]
    }]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedUsername = localStorage.getItem("apUsername");
        if (storedUsername) {
            setUsername(storedUsername);
        }
        fetchEntryData();
    }, [id]);

    const fetchEntryData = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("apUserToken");
            if (!token) {
                alert('Authentication token not found. Please login again.');
                setLoading(false);
                return;
            }

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}barrelBlanket/${id}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            if (response.data.success) {
                const entryData = response.data.data;
                setCompanyName(entryData.companyName || '');
                setUtility(entryData.utility || '');
                setCity(entryData.city || '');
                setState(entryData.state || '');

                let globalSectionIdCounter = 1;
                const transformedEntries = entryData.barrelEntries?.map((entry, index) => ({
                    id: entry.id || index + 1,
                    equipmentId: entry.equipmentId || '',
                    model: entry.model || '',
                    size: entry.size || '',
                    setpointTemp: entry.setpointTemp || '',
                    orientation: entry.orientation || '',
                    typeOfCooling: entry.typeOfCooling || '',
                    shrouding: entry.shrouding || false,
                    insulation: entry.insulation || false,
                    notes: entry.notes || '',
                    equipmentSectionsSizes: entry.equipmentSectionsSizes?.map((section) => ({
                        id: globalSectionIdCounter++,
                        circumference: section.circumference || '',
                        width: section.width || '',
                        surfaceArea: section.surfaceArea || 0,
                        tb: section.tb || '',
                        notes: section.notes || ''
                    })) || [{ id: globalSectionIdCounter++, circumference: '', width: '', surfaceArea: 0, tb: '', notes: '' }]
                })) || [];

                setBarrelEntries(transformedEntries);
            } else {
                alert(response.data.message || 'Failed to fetch entry');
            }
        } catch (error) {
            console.error('API Error:', error);
            alert('Failed to fetch entry. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const loadDraftData = (draftData) => {
        setCompanyName(draftData.companyName || '');
        setUtility(draftData.utility || '');
        setCity(draftData.city || '');
        setState(draftData.state || '');

        const entriesWithIds = (draftData.barrelEntries || [{
            ...initialFormState,
            id: 1,
            equipmentSectionsSizes: [{
                id: 1,
                circumference: '',
                width: '',
                surfaceArea: 0,
                tb: '',
                notes: ''
            }]
        }]).map((entry, entryIndex) => ({
            ...entry,
            id: entry.id || entryIndex + 1,
            equipmentSectionsSizes: entry.equipmentSectionsSizes.map((section, index) => ({
                ...section,
                id: section.id || index + 1
            }))
        }));

        setBarrelEntries(entriesWithIds);
    };

    const addNewEntry = () => {
        const newId = barrelEntries.length + 1;
        const maxSectionId = Math.max(...barrelEntries.flatMap(e => e.equipmentSectionsSizes.map(s => s.id)), 0);
        setBarrelEntries([...barrelEntries, {
            ...initialFormState,
            id: newId,
            equipmentSectionsSizes: [{
                id: maxSectionId + 1,
                circumference: '',
                width: '',
                surfaceArea: 0,
                tb: '',
                notes: ''
            }]
        }]);
    };

    const updateEntry = (id, field, value) => {
        setBarrelEntries(barrelEntries.map(entry =>
            entry.id === id ? { ...entry, [field]: value } : entry
        ));
    };

    const deleteEntry = (id) => {
        if (window.confirm('Are you sure you want to delete this entry?')) {
            setBarrelEntries(barrelEntries.filter(entry => entry.id !== id));
        }
    };

    const addNewEquipmentSectionsSizes = (barrelEntryId) => {
        setBarrelEntries(barrelEntries.map(entry => {
            if (entry.id === barrelEntryId) {
                const maxId = Math.max(...barrelEntries.flatMap(e => e.equipmentSectionsSizes.map(s => s.id)), 0);
                return {
                    ...entry,
                    equipmentSectionsSizes: [
                        ...entry.equipmentSectionsSizes,
                        {
                            id: maxId + 1,
                            circumference: '',
                            width: '',
                            surfaceArea: 0,
                            tb: '',
                            notes: ''
                        }
                    ]
                };
            }
            return entry;
        }));
    };

    const deleteEquipmentSectionsSizes = (sectionId, barrelEntryId) => {
        if (window.confirm('Are you sure you want to delete this section?')) {
            setBarrelEntries(barrelEntries.map(entry => {
                if (entry.id === barrelEntryId) {
                    return {
                        ...entry,
                        equipmentSectionsSizes: entry.equipmentSectionsSizes.filter(section => section.id !== sectionId)
                    };
                }
                return entry;
            }));
        }
    };

    const updateEquipmentSectionsSizes = (sectionId, field, value, barrelEntryId) => {
        setBarrelEntries(barrelEntries.map(entry => {
            if (entry.id === barrelEntryId) {
                return {
                    ...entry,
                    equipmentSectionsSizes: entry.equipmentSectionsSizes.map(section => {
                        if (section.id === sectionId) {
                            const updatedSection = { ...section, [field]: value };

                            if (field === 'circumference' || field === 'width') {
                                const surfaceArea = calculateSurfaceArea(updatedSection.circumference, updatedSection.width);
                                updatedSection.surfaceArea = surfaceArea;
                            }

                            return updatedSection;
                        }
                        return section;
                    })
                };
            }
            return entry;
        }));
    };

    const calculateSurfaceArea = (circumference, width) => {
        if (!circumference || !width) return 0;
        const circumferenceNum = parseFloat(circumference);
        const widthNum = parseFloat(width);
        if (isNaN(circumferenceNum) || isNaN(widthNum)) return 0;
        return circumferenceNum * widthNum;
    };

    const calculateTotalSurfaceArea = (equipmentSectionsSizes) => {
        const totalInches = equipmentSectionsSizes.reduce((sum, section) => {
            const surfaceArea = calculateSurfaceArea(section.circumference, section.width);
            return sum + surfaceArea;
        }, 0);
        return totalInches / 12;
    };

    const submitFormData = async () => {
        setIsSubmitting(true);

        try {
            const validationErrors = [];

            barrelEntries.forEach((entry, entryIndex) => {
                const entryNumber = entryIndex + 1;

                if (!entry.orientation || entry.orientation.trim() === '') {
                    validationErrors.push(`IMM #${entryNumber}: Barrel Orientation is required`);
                }

                if (!entry.typeOfCooling || entry.typeOfCooling.trim() === '') {
                    validationErrors.push(`IMM #${entryNumber}: Type of Cooling is required`);
                }

                entry.equipmentSectionsSizes.forEach((section, sectionIndex) => {
                    const sectionNumber = sectionIndex + 1;
                    if (!section.tb || section.tb.trim() === '') {
                        validationErrors.push(`IMM #${entryNumber}, Section ${sectionNumber}: Throw Blanket (TB) is required`);
                    }
                });
            });

            if (validationErrors.length > 0) {
                alert('Required Fields Missing:\n' + validationErrors.join('\n'));
                setIsSubmitting(false);
                return;
            }

            const token = localStorage.getItem("apUserToken");

            if (!token) {
                alert('Authentication token not found. Please login again.');
                setIsSubmitting(false);
                return;
            }

            const payload = {
                username: username,
                companyName: companyName,
                utility: utility,
                city: city,
                state: state,
                barrelEntries: barrelEntries.map(entry => ({
                    equipmentId: entry.equipmentId,
                    model: entry.model,
                    size: entry.size,
                    setpointTemp: entry.setpointTemp,
                    orientation: entry.orientation,
                    typeOfCooling: entry.typeOfCooling,
                    shrouding: entry.shrouding,
                    insulation: entry.insulation,
                    notes: entry.notes,
                    equipmentSectionsSizes: entry.equipmentSectionsSizes.map(section => ({
                        id: section.id,
                        circumference: section.circumference,
                        width: section.width,
                        surfaceArea: section.surfaceArea,
                        tb: section.tb,
                        notes: section.notes
                    }))
                }))
            };

            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}barrelBlanket/${id}`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            if (response.data.success) {
                setShowSuccessDialog(true);
            } else {
                alert(response.data.message || 'Failed to update form');
            }
        } catch (error) {
            console.error('API Error:', error);
            alert('Failed to update form. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSuccessDialogClose = () => {
        setShowSuccessDialog(false);
        navigate(`/barrel-blanket/details/${id}`);
    };

    const renderBarrelEntry = (entry, entryNumber) => (
        <div key={entry.id} className="mb-4 p-4 bg-gray-50 rounded-lg border border-gray-300">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold text-gray-800">IMM #{entryNumber}</h3>
                <button onClick={() => deleteEntry(entry.id)} className="text-red-600 hover:text-red-800">
                    <MdDelete size={24} />
                </button>
            </div>

            <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Equipment ID:</label>
                        <input
                            type="text"
                            className="w-full border border-gray-300 rounded px-3 py-2"
                            value={entry.equipmentId}
                            onChange={(e) => updateEntry(entry.id, 'equipmentId', e.target.value)}
                            placeholder="Enter Equipment ID"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Model:</label>
                        <input
                            type="text"
                            className="w-full border border-gray-300 rounded px-3 py-2"
                            value={entry.model}
                            onChange={(e) => updateEntry(entry.id, 'model', e.target.value)}
                            placeholder="Enter Model"
                        />
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Size (Tons):</label>
                        <input
                            type="number"
                            className="w-full border border-gray-300 rounded px-3 py-2"
                            value={entry.size}
                            onChange={(e) => updateEntry(entry.id, 'size', e.target.value)}
                            placeholder="Enter Size"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Setpoint Temp (°F):</label>
                        <input
                            type="number"
                            className="w-full border border-gray-300 rounded px-3 py-2"
                            value={entry.setpointTemp}
                            onChange={(e) => updateEntry(entry.id, 'setpointTemp', e.target.value)}
                            placeholder="Enter Setpoint"
                        />
                    </div>
                </div>
            </div>

            <div className="mt-6">
                <h4 className="text-md font-bold text-gray-800 mb-3">Material Being Processed:</h4>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Barrel Orientation:</label>
                        <select
                            className="w-full border border-gray-300 rounded px-3 py-2"
                            value={entry.orientation}
                            onChange={(e) => updateEntry(entry.id, 'orientation', e.target.value)}
                        >
                            <option value="">Select Orientation</option>
                            <option value="Horizontal">Horizontal</option>
                            <option value="Vertical">Vertical</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Type of Cooling:</label>
                        <select
                            className="w-full border border-gray-300 rounded px-3 py-2"
                            value={entry.typeOfCooling}
                            onChange={(e) => updateEntry(entry.id, 'typeOfCooling', e.target.value)}
                        >
                            <option value="">Select Type of Cooling</option>
                            <option value="Free-air">Free-air</option>
                            <option value="Compressed Air">Compressed Air</option>
                            <option value="Thermolator (oil-Injected)">Thermolator (oil-Injected)</option>
                        </select>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div className="flex items-center gap-3">
                        <label className="text-sm font-medium text-gray-700">Shrouding:</label>
                        <input
                            type="checkbox"
                            checked={entry.shrouding}
                            onChange={(e) => updateEntry(entry.id, 'shrouding', e.target.checked)}
                            className="w-5 h-5"
                        />
                    </div>
                    <div className="flex items-center gap-3">
                        <label className="text-sm font-medium text-gray-700">Ceramic Insulation:</label>
                        <input
                            type="checkbox"
                            checked={entry.insulation}
                            onChange={(e) => updateEntry(entry.id, 'insulation', e.target.checked)}
                            className="w-5 h-5"
                        />
                    </div>
                </div>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Notes:</label>
                    <textarea
                        className="w-full border border-gray-300 rounded px-3 py-2 h-24"
                        value={entry.notes}
                        onChange={(e) => updateEntry(entry.id, 'notes', e.target.value)}
                        placeholder="Enter Notes"
                    />
                </div>

                <div className="mb-4">
                    <h4 className="text-md font-bold text-gray-800 mb-3">Equipment Sections & Sizes:</h4>
                    {entry.equipmentSectionsSizes.map((section, index) => renderEquipmentSectionsSizes(section, index + 1, entry.id))}
                    <button
                        onClick={() => addNewEquipmentSectionsSizes(entry.id)}
                        className="flex items-center gap-2 mt-3 px-4 py-2 bg-teal-600 text-white rounded hover:bg-teal-700"
                    >
                        <MdAdd size={20} />
                        <span>Add New Section</span>
                    </button>
                </div>

                <div className="mt-4 p-3 bg-blue-50 border border-teal-600 rounded">
                    <p className="text-sm font-bold text-teal-600 text-center">
                        Total Surface Area: {calculateTotalSurfaceArea(entry.equipmentSectionsSizes).toFixed(2)} ft²
                    </p>
                </div>
            </div>
        </div>
    );

    const renderEquipmentSectionsSizes = (section, sectionNumber, barrelEntryId) => (
        <div key={section.id} className="mb-4 p-4 bg-gray-50 rounded-lg border border-gray-300">
            <div className="flex justify-between items-center mb-3">
                <h5 className="text-sm font-bold text-gray-800">Section {sectionNumber}:</h5>
                <button onClick={() => deleteEquipmentSectionsSizes(section.id, barrelEntryId)} className="text-red-600 hover:text-red-800">
                    <MdDelete size={20} />
                </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Circumference (in):</label>
                    <input
                        type="number"
                        className="w-full border border-gray-300 rounded px-3 py-2"
                        value={section.circumference}
                        onChange={(e) => updateEquipmentSectionsSizes(section.id, 'circumference', e.target.value, barrelEntryId)}
                        placeholder="Enter Circumference"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Width (in):</label>
                    <input
                        type="number"
                        className="w-full border border-gray-300 rounded px-3 py-2"
                        value={section.width}
                        onChange={(e) => updateEquipmentSectionsSizes(section.id, 'width', e.target.value, barrelEntryId)}
                        placeholder="Enter Width"
                    />
                </div>
            </div>

            <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Throw Blanket (TB):</label>
                <select
                    className="w-full border border-gray-300 rounded px-3 py-2"
                    value={section.tb}
                    onChange={(e) => updateEquipmentSectionsSizes(section.id, 'tb', e.target.value, barrelEntryId)}
                >
                    <option value="">Select Throw Blanket (TB)</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>
            </div>

            <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Section Notes:</label>
                <textarea
                    className="w-full border border-gray-300 rounded px-3 py-2 h-24"
                    value={section.notes}
                    onChange={(e) => updateEquipmentSectionsSizes(section.id, 'notes', e.target.value, barrelEntryId)}
                    placeholder="Enter Section Notes"
                />
            </div>

            <div className="p-2 bg-blue-50 border border-teal-600 rounded">
                <p className="text-sm font-bold text-teal-600 text-center">
                    Surface Area: {section.surfaceArea.toFixed(2)} in²
                </p>
            </div>
        </div>
    );

    if (loading) {
        return (
            <div className="min-h-screen bg-gray-100">
                <div className="bg-teal-600 text-white p-4 shadow-md">
                    <div className="flex items-center gap-4">
                        <button onClick={() => navigate('/barrel-blanket')} className="text-white hover:text-gray-200">
                            <BiArrowBack size={24} />
                        </button>
                        <h1 className="text-2xl font-bold">Edit Barrel Blanket Form</h1>
                    </div>
                </div>
                        <div className="flex items-center justify-center h-64">
                    <div className="text-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600 mx-auto mb-4"></div>
                        <p className="text-gray-600">Loading form...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-100">
            {/* Header */}
            <div className="bg-teal-600 text-white p-4 shadow-md">
                <div className="flex items-center gap-4">
                    <button onClick={() => navigate('/barrel-blanket')} className="text-white hover:text-gray-200">
                        <BiArrowBack size={24} />
                    </button>
                    <h1 className="text-2xl font-bold">
                        Edit Barrel Blanket Form
                    </h1>
                </div>
            </div>

            {/* Form */}
            <div className="container mx-auto p-4 max-w-6xl">
                <div className="bg-white rounded-lg shadow-md p-6 mb-4">
                    <h2 className="text-xl font-bold mb-4 text-center">
                        Edit Barrel Blanket Form
                    </h2>

                    <div className="space-y-4">
                        <div className="flex items-center gap-4">
                            <label className="w-40 font-medium text-red-600">Date*:</label>
                            <span>{new Date(date).toLocaleString()}</span>
                        </div>

                        <div className="flex items-center gap-4">
                            <label className="w-40 font-medium text-red-600">User*:</label>
                            <span>{username}</span>
                        </div>

                        <div className="flex items-center gap-4">
                            <label className="w-40 font-medium text-red-600">Company*:</label>
                            <input
                                type="text"
                                className="flex-1 border border-gray-300 rounded px-3 py-2"
                                placeholder="Enter Company Name"
                                value={companyName}
                                onChange={(e) => setCompanyName(e.target.value)}
                            />
                        </div>

                        <div className="flex items-center gap-4">
                            <label className="w-40 font-medium">Company Contact:</label>
                            <input
                                type="text"
                                className="flex-1 border border-gray-300 rounded px-3 py-2"
                                placeholder="Enter Utility"
                                value={utility}
                                onChange={(e) => setUtility(e.target.value)}
                            />
                        </div>

                        <div className="flex items-center gap-4">
                            <label className="w-40 font-medium">City:</label>
                            <input
                                type="text"
                                className="flex-1 border border-gray-300 rounded px-3 py-2"
                                placeholder="Enter City"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                            />
                        </div>

                        <div className="flex items-center gap-4">
                            <label className="w-40 font-medium">State:</label>
                            <select
                                className="flex-1 border border-gray-300 rounded px-3 py-2"
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                            >
                                <option value="">Select State</option>
                                {stateData.map((stateItem) => (
                                    <option key={stateItem.value} value={stateItem.value}>
                                        {stateItem.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                {/* Barrel Entries */}
                <div className="bg-white rounded-lg shadow-md p-6 mb-4">
                    <h3 className="text-lg font-bold mb-4">Blanket Entries</h3>
                    {barrelEntries.map((entry, index) => renderBarrelEntry(entry, index + 1))}
                    <button
                        onClick={addNewEntry}
                        className="flex items-center gap-2 mt-4 px-4 py-2 bg-teal-600 text-white rounded hover:bg-teal-700"
                    >
                        <MdAdd size={20} />
                        <span>Add New IMM Entry</span>
                    </button>
                </div>

                {/* Action Buttons */}
                <div className="flex gap-4 mb-6">
                    <button
                    onClick={submitFormData}
                    disabled={isSubmitting}
                    className={`flex-1 px-6 py-3 rounded-lg font-semibold ${
                        isSubmitting
                            ? 'bg-gray-400 cursor-not-allowed'
                            : 'bg-teal-600 text-white hover:bg-teal-700'
                    }`}
                >
                    {isSubmitting ? (
                        <span className="flex items-center justify-center gap-2">
                            <span className="animate-spin">⏳</span>
                            Updating...
                        </span>
                    ) : (
                        'Update Entry'
                    )}
                    </button>
                </div>
            </div>

            {/* Success Dialog */}
            {showSuccessDialog && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-8 max-w-md mx-4 shadow-xl">
                        <div className="flex justify-center mb-4">
                            <AiOutlineCheckCircle size={60} className="text-green-500" />
                        </div>
                        <h3 className="text-xl font-bold text-center mb-4">Success!</h3>
                        <p className="text-center text-gray-600 mb-6">
                            Your barrel blanket form has been updated successfully.
                        </p>
                        <button
                            onClick={handleSuccessDialogClose}
                            className="w-full px-6 py-3 bg-teal-600 text-white rounded-lg font-semibold hover:bg-teal-700"
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BarrelBlanketEditForm;

